import { useState, useCallback } from 'react';
import { homeExpenseImportExportApi, ImportValidationResult, ImportResult, ExportOptions } from '../services/homeExpenseImportExportApi';

export const useHomeExpenseImportExport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validateFile = useCallback(async (file: File): Promise<ImportValidationResult | null> => {
    setLoading(true);
    setError(null);
    try {
      const result = await homeExpenseImportExportApi.validateImportFile(file);
      return result;
    } catch (err: any) {
      setError(err.message || 'Não foi possível validar o ficheiro');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const importFile = useCallback(async (file: File, clearExistingData: boolean = false): Promise<ImportResult | null> => {
    setLoading(true);
    setError(null);
    try {
      const result = await homeExpenseImportExportApi.importHomeExpenses(file, clearExistingData);
      return result;
    } catch (err: any) {
      setError(err.message || 'Não foi possível importar o ficheiro');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const exportData = useCallback(async (options: ExportOptions): Promise<Blob | null> => {
    setLoading(true);
    setError(null);
    try {
      const blob = await homeExpenseImportExportApi.exportHomeExpenses(options);
      return blob;
    } catch (err: any) {
      setError(err.message || 'Não foi possível exportar os dados');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const downloadTemplate = useCallback(async (format: 'Csv' | 'Xlsx'): Promise<Blob | null> => {
    setLoading(true);
    setError(null);
    try {
      const blob = await homeExpenseImportExportApi.downloadTemplate(format);
      return blob;
    } catch (err: any) {
      setError(err.message || 'Não foi possível descarregar o modelo');
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const downloadFile = useCallback((blob: Blob, fileName: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }, []);

  return {
    loading,
    error,
    validateFile,
    importFile,
    exportData,
    downloadTemplate,
    downloadFile,
    clearError: () => setError(null)
  };
};
